import { render, staticRenderFns } from "./MapShapeItem.vue?vue&type=template&id=e4a401e8&lang=pug&"
import script from "./MapShapeItem.vue?vue&type=script&lang=js&"
export * from "./MapShapeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MapShapeItem.vue"
export default component.exports